import React, { useState } from "react";
import { Form, Button } from "react-bootstrap";
import { useContacts } from "../contexts/ContactsProvider";
import { useConversations } from "../contexts/ConversationsProvider";
import { FormGroup, Label, Input } from "reactstrap";
import swal from "sweetalert";
import { DOMAIN } from "../utils";
import avatar from "../../assets/img/default-avatar.png";
import { Modal, ModalBody, ModalFooter, ModalHeader, Badge } from "reactstrap";

export default function NewConversationModal({ closeModal, id }) {
  const [selectedContactIds, setSelectedContactIds] = useState([]);
  const { contacts } = useContacts();
  const { createConversation } = useConversations();

  const [modalOpen, setModalOpen] = useState(false);
  const [namaGroup, setNamaGroup] = useState("");
  const contactsFilter = contacts.filter((item) => {
    return item.id != id;
  });

  function handleSubmit(e) {
    e.preventDefault();
    if (selectedContactIds.length == 0) {
      return swal("Info", "Belum ada kotak yang dipilih", "info");
    } else if (selectedContactIds.length > 1) {
      return setModalOpen(true);
    } else if (selectedContactIds.length == 1) {
      lanjutSimpan();
    }
  }

  const lanjutSimpan = () => {
    createConversation(selectedContactIds, namaGroup);
    onModalClose();
    closeModal();
  };

  function handleCheckboxChange(contactId) {
    setSelectedContactIds((prevSelectedContactIds) => {
      if (prevSelectedContactIds.includes(contactId)) {
        return prevSelectedContactIds.filter((prevId) => {
          return contactId !== prevId;
        });
      } else {
        return [...prevSelectedContactIds, contactId];
      }
    });
  }

  const onModalClose = () => {
    setModalOpen(false);
    setNamaGroup("");
  };

  function findContactNameById(id) {
    const contact = contacts.find((contact) => contact.id === id);
    return contact ? contact.name : undefined;
  }

  return (
    <>
      <Form onSubmit={handleSubmit} style={{ padding: "10px 0" }}>
        <div style={{ maxHeight: "400px", overflowY: "auto", padding: "10px" }}>
          {contactsFilter.map((contact) => {
            const isSelected = selectedContactIds.includes(contact.id);
            return (
              <div
                key={contact.id}
                style={{
                  marginBottom: 12,
                  padding: "12px",
                  borderRadius: "12px",
                  backgroundColor: isSelected ? "#f0f4ff" : "#ffffff",
                  border: isSelected
                    ? "2px solid #667eea"
                    : "2px solid #e9ecef",
                  cursor: "pointer",
                  transition: "all 0.2s ease",
                }}
                onClick={() => handleCheckboxChange(contact.id)}
                onMouseEnter={(e) => {
                  if (!isSelected) {
                    e.currentTarget.style.backgroundColor = "#f8f9fa";
                    e.currentTarget.style.borderColor = "#dee2e6";
                  }
                }}
                onMouseLeave={(e) => {
                  if (!isSelected) {
                    e.currentTarget.style.backgroundColor = "#ffffff";
                    e.currentTarget.style.borderColor = "#e9ecef";
                  }
                }}
              >
                <FormGroup check style={{ margin: 0 }}>
                  <div style={{ display: "flex", alignItems: "center" }}>
                    <img
                      style={{
                        width: 40,
                        height: 40,
                        borderRadius: "50%",
                        marginRight: 12,
                        objectFit: "cover",
                        border: "2px solid #e9ecef",
                        boxShadow: "0 2px 4px rgba(0,0,0,0.1)",
                        display: "block",
                      }}
                      src={
                        contact.profile && contact.profile !== "-"
                          ? DOMAIN + contact.profile
                          : avatar
                      }
                      alt={contact.name}
                      onError={(e) => {
                        e.target.src = avatar;
                      }}
                    />
                    <Label
                      check
                      style={{ margin: 0, flex: 1, cursor: "pointer" }}
                    >
                      <Input
                        type="checkbox"
                        checked={isSelected}
                        onChange={() => handleCheckboxChange(contact.id)}
                        style={{ marginRight: 8 }}
                      />
                      <span
                        style={{
                          fontWeight: 500,
                          fontSize: "15px",
                          color: "#2c3e50",
                        }}
                      >
                        {contact.name}
                      </span>
                    </Label>
                  </div>
                </FormGroup>
              </div>
            );
          })}
        </div>
        <div
          style={{
            padding: "15px",
            borderTop: "1px solid #e9ecef",
            marginTop: "10px",
          }}
        >
          <Button
            type="submit"
            style={{
              width: "100%",
              borderRadius: "25px",
              backgroundColor: "#667eea",
              border: "none",
              padding: "12px 20px",
              fontWeight: 600,
              boxShadow: "0 4px 15px rgba(102, 126, 234, 0.4)",
              transition: "all 0.3s ease",
            }}
            onMouseEnter={(e) => {
              e.target.style.backgroundColor = "#5568d3";
              e.target.style.transform = "translateY(-2px)";
              e.target.style.boxShadow = "0 6px 20px rgba(102, 126, 234, 0.5)";
            }}
            onMouseLeave={(e) => {
              e.target.style.backgroundColor = "#667eea";
              e.target.style.transform = "translateY(0)";
              e.target.style.boxShadow = "0 4px 15px rgba(102, 126, 234, 0.4)";
            }}
          >
            ➕ Buat Percakapan
          </Button>
        </div>
      </Form>
      <Modal
        size="sm"
        isOpen={modalOpen}
        toggle={() => setModalOpen(false)}
        contentClassName="p-0"
        modalClassName="modal-slide-in event-sidebar"
      >
        <ModalHeader toggle={() => setModalOpen(false)}></ModalHeader>
        <ModalBody style={{ padding: "25px" }}>
          <FormGroup>
            <Label
              style={{
                fontWeight: 600,
                color: "#2c3e50",
                marginBottom: "10px",
                fontSize: "14px",
              }}
            >
              Nama Group
            </Label>
            <Input
              value={namaGroup}
              type="text"
              onChange={(e) => setNamaGroup(e.target.value)}
              placeholder="Masukkan nama group..."
              style={{
                borderRadius: "10px",
                border: "2px solid #e9ecef",
                padding: "12px 16px",
                fontSize: "14px",
                transition: "all 0.3s ease",
              }}
              onFocus={(e) => {
                e.target.style.borderColor = "#667eea";
                e.target.style.boxShadow = "0 0 0 3px rgba(102, 126, 234, 0.1)";
              }}
              onBlur={(e) => {
                e.target.style.borderColor = "#e9ecef";
                e.target.style.boxShadow = "none";
              }}
            />
          </FormGroup>

          <FormGroup style={{ marginTop: "20px" }}>
            <div
              style={{
                display: "flex",
                alignItems: "center",
                gap: "10px",
                marginBottom: "10px",
              }}
            >
              <span
                style={{
                  fontWeight: 600,
                  color: "#667eea",
                  fontSize: "14px",
                }}
              >
                Anggota Group
              </span>
              <Badge
                style={{
                  backgroundColor: "#fd5c63",
                  padding: "4px 10px",
                  borderRadius: "12px",
                  fontSize: "12px",
                  fontWeight: 600,
                }}
              >
                {selectedContactIds.length}
              </Badge>
            </div>
            <div
              style={{
                padding: "12px",
                backgroundColor: "#f8f9fa",
                borderRadius: "10px",
                border: "1px solid #e9ecef",
                maxHeight: "150px",
                overflowY: "auto",
              }}
            >
              <Label
                style={{
                  color: "#6c757d",
                  fontSize: "13px",
                  margin: 0,
                }}
              >
                {selectedContactIds
                  .map((r) => findContactNameById(r))
                  .join(", ")}
              </Label>
            </div>
          </FormGroup>
        </ModalBody>
        <ModalFooter
          style={{
            justifyContent: "center",
            padding: "20px 25px",
            borderTop: "1px solid #e9ecef",
          }}
        >
          <div
            style={{
              display: "flex",
              flexDirection: "row",
              gap: "10px",
              width: "100%",
            }}
          >
            <Button
              style={{
                flex: 1,
                borderRadius: "25px",
                backgroundColor: "#6c757d",
                border: "none",
                padding: "10px 20px",
                fontWeight: 600,
                transition: "all 0.3s ease",
              }}
              onClick={onModalClose}
              onMouseEnter={(e) => {
                e.target.style.backgroundColor = "#5a6268";
                e.target.style.transform = "translateY(-2px)";
              }}
              onMouseLeave={(e) => {
                e.target.style.backgroundColor = "#6c757d";
                e.target.style.transform = "translateY(0)";
              }}
            >
              Batal
            </Button>
            <Button
              style={{
                flex: 1,
                borderRadius: "25px",
                backgroundColor: "#667eea",
                border: "none",
                padding: "10px 20px",
                fontWeight: 600,
                boxShadow: "0 4px 15px rgba(102, 126, 234, 0.4)",
                transition: "all 0.3s ease",
              }}
              onClick={() => {
                if (namaGroup) {
                  lanjutSimpan();
                } else {
                  swal("Info", "Nama group harus diinput", "info");
                }
              }}
              onMouseEnter={(e) => {
                e.target.style.backgroundColor = "#5568d3";
                e.target.style.transform = "translateY(-2px)";
                e.target.style.boxShadow =
                  "0 6px 20px rgba(102, 126, 234, 0.5)";
              }}
              onMouseLeave={(e) => {
                e.target.style.backgroundColor = "#667eea";
                e.target.style.transform = "translateY(0)";
                e.target.style.boxShadow =
                  "0 4px 15px rgba(102, 126, 234, 0.4)";
              }}
            >
              Simpan
            </Button>
          </div>
        </ModalFooter>
      </Modal>
    </>
  );
}
